module.exports = __webpack_public_path__ + "static/media/gif2.9b6bd5d7.gif";